import { useGameStore } from '@campus/core';
import { logout } from '../../bridge/GameBridge.js';
import { useIsMobile } from '../hooks/useIsMobile.js';
import { Button, Icon } from '../ds/index.js';

/**
 * SessionReplacedPage — affichée si authState === 'replaced' : le même compte
 * est entré dans le campus depuis une autre fenêtre ou un autre appareil, et
 * la dernière connexion l'emporte (ZoneRoom.replaceOlderSessions).
 *
 * Le JWT est conservé : « Revenir ici » repasse en 'in-game' (même carte,
 * même position), ce qui évince à son tour l'autre fenêtre.
 */
export function SessionReplacedPage() {
  const setAuthState = useGameStore((s) => s.setAuthState);
  const isMobile = useIsMobile();

  return (
    <div
      className="pl-page"
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: '100vw', height: '100dvh', boxSizing: 'border-box',
        padding: 'var(--space-4)',
      }}
    >
      <main
        style={{
          width: '100%', maxWidth: 440, boxSizing: 'border-box',
          padding: isMobile ? 'var(--space-6) var(--space-4)' : 'var(--space-8)',
          background: 'var(--color-bg-surface)',
          border: '1px solid var(--color-border-default)',
          borderRadius: 'var(--radius-xl)',
          boxShadow: 'var(--shadow-lg)',
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          gap: 'var(--space-4)', textAlign: 'center',
        }}
      >
        <div aria-hidden="true" style={{
          width: 48, height: 48, borderRadius: 'var(--radius-full)',
          background: 'var(--color-bg-raised)', color: 'var(--color-text-secondary)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Icon name="monitor" size={22} />
        </div>
        <h1 style={{
          margin: 0,
          fontFamily: 'var(--font-display)',
          fontWeight: 'var(--font-extrabold)' as unknown as number,
          fontSize: 'var(--text-xl)',
          lineHeight: 'var(--leading-tight)',
          letterSpacing: 'var(--tracking-tight)',
          color: 'var(--color-text-primary)',
        }}>
          Campus ouvert dans une autre fenêtre
        </h1>
        <p style={{ margin: 0, fontSize: 'var(--text-base)', lineHeight: 'var(--leading-normal)', color: 'var(--color-text-secondary)' }}>
          Ton compte vient d'entrer dans le campus depuis une autre fenêtre ou un autre appareil.
          Une seule connexion à la fois : tu peux reprendre la main ici.
        </p>
        <div style={{
          display: 'flex', gap: 'var(--space-3)', width: '100%',
          flexDirection: isMobile ? 'column' : 'row', justifyContent: 'center',
          paddingTop: 'var(--space-2)',
        }}>
          <Button variant="secondary" onClick={() => { void logout(); }}>
            Se déconnecter
          </Button>
          <Button variant="primary" onClick={() => setAuthState('in-game')}>
            Revenir ici
          </Button>
        </div>
      </main>
    </div>
  );
}
